function MapPlaces() {
    var that = this;

    //Default Options Values
    var options = {
        googleMapContainerId: 'mapPlacesMapContainer',
        resultListContainerSelector: '#mapPlacesResultList',
        citySearchSelector: null,
        defaultIcon: null,
        hoverIcon: null,
        renderListEntry: function(place){return '<div>'+place[options.place.markerTitleKey]+'<hr></div>';},
        renderMapsInfoBox: function(place){return '<div>'+place[options.place.markerTitleKey]+'</div>';},
        place:{
            latKey: 'lat',
            lngKey: 'lng',
            markerTitleKey: 'title'
        }
    };

    if(arguments.length) {
        var argumentOptions = arguments[0];
        for (var attrname in argumentOptions) { options[attrname] = argumentOptions[attrname]; }
    }

    const mapContainer = document.getElementById(options.googleMapContainerId);

    var places = [];
    var $mapsContainer = $('#'+options.googleMapContainerId);
    var $resultListContainer = $(options.resultListContainerSelector);
    var map = null;
    var markers = [];
    var resultListEntries = [];
    let geocoder;

    this.initMap = function () {
        // Create a map object and specify the DOM element for display.
        map = new google.maps.Map(document.getElementById(options.googleMapContainerId), {
            center: {lat: 51.165691, lng: 10.451526},
            zoom: 6
        });

        mapContainer.classList.remove('map-not-loaded');
        geocoder = new google.maps.Geocoder();

        initCitySearchAutocomplete();
    };

    this.refresh = function () {
        renderPlaces(places);
    };

    this.setPlaces = function (newPlaces) {
        places = newPlaces;
        that.refresh();
    };

    this.centerMapAtLatLng = function (latlng) {
        map.setCenter(latlng);
        map.setZoom(11);
    };

    this.centerMapAtAddress = function (address) {
        this.getLocation(address, function (data) {
            map.setCenter(data);
            map.setZoom(11);
        });
    };

    this.clickMarkerByIndex = function(index) {
        if (markers[index]) {
            google.maps.event.trigger(markers[index], 'click');
        }
    }

    this.getLocation = function (address, callback) {
        if (address === '') {
            callback(null);
            return;
        }
        geocoder
            .geocode({address: address})
            .then((result) => {
                const {results} = result;
                callback(results[0].geometry.location);
            })
            .catch((e) => {
                console.log("Geocoder failed due to: " + e);
                callback(null);
            });
    };

    this.navigatorLocate = function (callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var cityName = '';
                var params = {"lat": position.coords.latitude + ',' + position.coords.longitude};
                const latlng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                geocoder
                    .geocode({location: latlng})
                    .then((data) => {
                        if (data.results[0]) {
                            for (var i in data.results) {
                                var result = data.results[i];
                                if (result.types.indexOf("locality") === -1) {
                                    continue;
                                }
                                for (var z in result.address_components) {
                                    var address_component = result.address_components[z];
                                    if (address_component.types.indexOf("locality") !== -1) {
                                        cityName = address_component.long_name;
                                        callback(cityName);
                                    }
                                }
                            }
                        }
                    })
                    .catch((e) => console.log("Geocoder failed due to: " + e));
            });
        }
    };

    this.getMap = function () {
        return map;
    }

    function renderPlaces(places) {
        if(places.length === 0) {
            clearMarkersAndResultList();
        }else {
            renderPlacesOnMap(places);
            renderPlacesOnList(places);
        }
    }

    function deleteMarkers() {
        for(var i in markers){
            markers[i].setMap(null);
            markers[i].myInfoWindow.setMap(null);
        }
        markers = [];
    }

    function clearResultList() {
        resultListEntries = [];
        $resultListContainer.html('');
    }

    function clearMarkersAndResultList() {
        deleteMarkers();
        clearResultList();
    }

    function renderPlacesOnMap(places) {
        deleteMarkers();
        var bounds  = new google.maps.LatLngBounds();
        for(var i in places) {
            (function () {
                var place = places[i];
                place._placesIndex = i;

                var loc = new google.maps.LatLng(place[options.place.latKey], place[options.place.lngKey]);
                bounds.extend(loc);

                var infowindow = new google.maps.InfoWindow({
                    content: options.renderMapsInfoBox(place)
                });

                var marker = new google.maps.Marker({
                    position: {lat:place[options.place.latKey], lng:place[options.place.lngKey]},
                    map: map,
                    title: place[options.place.markerTitleKey],
                    icon: options.defaultIcon
                });
                marker.myInfoWindow = infowindow;
                var markerIndex = i;
                marker.addListener('click', function() {
                    for(var z in markers) {
                        markers[z].myInfoWindow.close();
                        markers[z].setIcon(options.defaultIcon);
                    }
                    infowindow.open(map, marker);
                    marker.setIcon(options.hoverIcon);
                    scrollToElementInResultList(markerIndex);
                });
                marker.addListener('mouseover', function() {
                    marker.setIcon(options.hoverIcon);
                });
                marker.addListener('mouseout', function() {
                    if(!marker.myInfoWindow.getMap()){
                        marker.setIcon(options.defaultIcon);
                    }
                });
                markers.push(marker);
            })();
        }

        map.fitBounds(bounds);
        map.panToBounds(bounds);
    }

    function renderPlacesOnList(places) {
        clearResultList();
        function hoverIn(e) {
            var marker = markers[$(this).data('marker-index')];
            marker.setIcon(options.hoverIcon);
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function () {marker.setAnimation(null);}, 800);
        }
        function hoverOut(e) {
            var marker = markers[$(this).data('marker-index')];
            if(!marker.myInfoWindow.getMap()) {
                marker.setIcon(options.defaultIcon);
            }
            //marker.setAnimation(null);
        }
        function entryClick(e) {
            //Wenn ein Link/A-Tag im Item-Element geklickt wurde, dann keine Animation etc ausführen.
            if(e.target && e.target.nodeName && e.target.nodeName === 'A') {
                return;
            }

            if($mapsContainer.css('visibility') === 'hidden') {
                return;
            }
            var markerIndex = $(this).data('marker-index');
            google.maps.event.trigger(markers[markerIndex], 'click');
        }
        for(var i in places) {
            var place = places[i];
            place._placesIndex = i;
            var newEntryHtml = options.renderListEntry(place);
            var $entry = $(newEntryHtml);
            //$entry.data('place', place);
            $entry.data('marker-index', i);
            $entry.hover(hoverIn,hoverOut);
            $entry.click(entryClick);
            resultListEntries[i] = $entry;
            $resultListContainer.append($entry);
        }
    }

    function scrollToElementInResultList(markerIndex) {
        var $entry = resultListEntries[markerIndex];

        var $placesSearchAndList = $('.map-places-search-and-list');
        if($placesSearchAndList.length) {
            $placesSearchAndList.animate({
                scrollTop: $entry.offset().top - $placesSearchAndList.offset().top + $placesSearchAndList.scrollTop()-35
            }, 400);
        }
        $('#mapPlacesResultList li').removeClass('highlight');
        $entry.addClass('highlight');
    }


    function init() {

        var $mapPlacesViewSwitcher = $('#mapPlacesViewSwitcher');
        if($mapPlacesViewSwitcher.length === 0) {
            return;
        }

        $mapPlacesViewSwitcher.on('click', '.nav-link',function (e) {
            e.preventDefault();
            var $lastActiveNavLink = $mapPlacesViewSwitcher.find('.active');
            $($lastActiveNavLink.attr('href')).removeClass('active');
            $lastActiveNavLink.removeClass('active');

            $(this).addClass('active');
            $($(this).attr('href')).addClass('active');
        });

        $mapsContainer.on('click', '[data-places-action="showInList"]',function (e) {
            e.preventDefault();
            $mapPlacesViewSwitcher.find('[data-places-action="showList"]').trigger('click');
            scrollToElementInResultList($(this).attr('data-places-index'));
        });

        $resultListContainer.on('click', '[data-places-action="showInMap"]',function (e) {
            e.preventDefault();
            $mapPlacesViewSwitcher.find('[data-places-action="showMap"]').trigger('click');
            var markerIndex = $(this).attr('data-places-index');
            google.maps.event.trigger(markers[markerIndex], 'click');
        });
    }

    function initCitySearchAutocomplete() {

        if(!options.citySearchSelector) {
            return;
        }

        window.$citySearch = $(options.citySearchSelector);
        if(!$citySearch.length){
            return;
        }

        var autocompleteOptions = {
            types: ['(cities)'],
            componentRestrictions: {country: 'de'}
        };

        var autocomplete = new google.maps.places.Autocomplete($citySearch[0], autocompleteOptions);

    }

    init();
}

export default MapPlaces;
